export interface Link {
    title: string
    url: string
    icon: string
}

export const links: Link[] = [
    {
        title: 'LinkedIn',
        url: 'https://www.linkedin.com/in/jason-smith-00884346/',
        icon: '/icons/linkedInLogo.png',
    },
    {
        title: 'Tiktok',
        url: 'https://www.tiktok.com/@colordodgelabs',
        icon: '/icons/tikTokIcon.png',
    },
    {
        title: 'YouTube',
        url: 'https://www.youtube.com/@colordodge',
        icon: '/icons/YouTube_full-color_icon.png',
    },
    {
        title: 'Maker World',
        url: 'https://makerworld.com/en/@colordodge',
        icon: '/icons/maker-world-dark.png',
    },
    {
        title: 'SoundCloud',
        url: 'https://soundcloud.com/user-193456677',
        icon: '/icons/soundcloud-square-color-icon.webp',
    },
    {
        title: 'GitHub',
        url: 'https://github.com/colordodge',
        icon: '/icons/github-logo.png',
    },
]

/** Stable ids for coordinated hide/show transitions in ContentFlow (one per link row). */
export function linkRowTransitionId(index: number): string {
    return `links-row-${index}`
}

export function linkRowTransitionIds(): string[] {
    return links.map((_, index) => linkRowTransitionId(index))
}